import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback, useState } from 'react';
import Modal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import Mini from '../../MuroEditor/preset/Mini';
const X_RESET_TIME = 1000;
const MiniModal = (_param)=>{
    var { deviation, onRequestClose, isOpen, heading } = _param, rest = _object_without_properties(_param, [
        "deviation",
        "onRequestClose",
        "isOpen",
        "heading"
    ]);
    const [closeRequested, setCloseRequested] = useState(false);
    const doClose = useCallback(()=>{
        onRequestClose && onRequestClose(null);
    }, [
        onRequestClose
    ]);
    const handleClose = useCallback(()=>{
        setCloseRequested(true);
        // This timeout is to "reset" the x button, so if the close gets cancelled the
        // user can try to close again later
        setTimeout(()=>{
            setCloseRequested(false);
        }, X_RESET_TIME);
    }, [
        setCloseRequested
    ]);
    return /*#__PURE__*/ React.createElement(Modal, _object_spread({
        heading: heading,
        isOpen: isOpen,
        showHeaderBorder: true,
        isFullscreen: true,
        onRequestClose: handleClose
    }, rest), /*#__PURE__*/ React.createElement(Mini, {
        deviation: deviation,
        onRequestClose: doClose,
        closeRequested: closeRequested
    }));
};
MiniModal.displayName = 'MiniModal';
export default MiniModal;

//# sourceMappingURL=MiniModal.js.map